import { TERMS } from "../../content/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { SectionHeading, Reveal } from "./Motion";

export const Terms = () => (
  <section id="terms" className="relative section-pad" data-testid="terms-section">
    <div className="mx-auto grid max-w-[1200px] gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <SectionHeading eyebrow="Good to know" title="Terms &" script="conditions" testid="terms-heading" />
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-ink-soft">Clear and simple, so you can focus on your celebration.</p>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-gold/25" data-testid="terms-accordion">
          {TERMS.map((t, i) => (
            <AccordionItem key={t.title} value={`item-${i}`} className="border-b border-gold/25">
              <AccordionTrigger className="py-6 text-left hover:no-underline" data-testid={`terms-trigger-${i}`}>
                <span className="flex items-baseline gap-5">
                  <span className="font-serif text-sm italic text-gold">0{i + 1}</span>
                  <span className="font-serif text-2xl text-ink sm:text-3xl">{t.title}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6 pl-10 text-[15px] leading-relaxed text-ink" data-testid={`terms-content-${i}`}>{t.text}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
